module.exports = __webpack_public_path__ + "img/idcard.b85f4124.png";